<template>
  <form ref="searchForm"
        class="top-bar-search"
        @submit.prevent="search">
    <div class="input-group input-group-search border">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <span class="fas fa-search"></span>
        </span>
      </div>
      <input id="s"
             v-model="searchInput"
             aria-label="Search"
             class="form-control"
             name="s"
             placeholder="Buscar en SIID"
             type="text">
    </div>
  </form>
</template>

<script>
  export default {
    name: 'SearchForm',
    data () {
      return {
        searchInput: null,
      }
    },
    methods: {
      async search () {
        location.href = `/buscar?s=${this.searchInput}`
      },
    },
    mounted() {
      if (this.$router && this.$router.currentRoute) {
        this.searchInput = this.$router.currentRoute.query.s
      }
    }
  }
</script>
